import { Tab, TabStopType, TextRun } from 'docx'
import { contentWidth, fontSize, itemSpacing } from './pageLayout'

/** Paragraph tab stops that align an item's date to the right edge of the page. */
export const itemHeadingTabStops = [{ type: TabStopType.RIGHT, position: contentWidth }]

/** Paragraph spacing that separates CV items from each other. */
export const itemParagraphSpacing = { after: itemSpacing }

/**
 * Creates the first row of a CV item: the name in bold and the date on the right of the same row,
 * like in the PDF. The paragraph needs `itemHeadingTabStops` for the date to be aligned right.
 *
 * @param {string} name - The item name, or an empty string when it is hidden.
 * @param {string} date - The item date, or an empty string when there is none or it is hidden.
 * @return {TextRun[]} The text runs of the row.
 */
export const itemHeading = (name: string, date: string): TextRun[] => [
  new TextRun({ text: name, bold: true }),
  ...(date ? [new TextRun({ children: [new Tab(), date], size: fontSize.small })] : []),
]
